var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElectric = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.768 2.05c-3.26 4.312-7.485 9.698-9.3 12.004H9.54c.711 0 1.27.588 1.211 1.274l-.592 6.9 8.902-11.782H13.95c-.739 0-1.306-.632-1.204-1.34l1.023-7.055ZM12.957.733c.23-.306.596-.482.981-.482h.166c.738 0 1.306.632 1.204 1.34l-1.08 7.444h5.312c.995 0 1.569 1.094.981 1.871L10.8 23.773c-.227.3-.587.477-.97.477-.704 0-1.257-.582-1.199-1.26l.646-7.524H3.978c-1 0-1.583-1.11-.968-1.89C4.674 11.464 9.475 5.355 12.957.732Z",
  clipRule: "evenodd"
})));
export default SvgElectric;